import { Component, ComponentRef, ElementRef, EventEmitter,
  HostListener, OnInit, Output, ViewChild,
  ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HtmlErrorComponent } from 'src/app/fragments/html-error/html-error.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { MssServiceFactory, MssTypeService } from 'src/app/services/mss/mss-service.factory';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { IdentifiantsTemporairesConnexion } from 'src/app/utils/interfaces/new/identifiantsTemporairesConnexion';
import { environment } from 'src/environments/environment';

enum MailizConnectStep {
  mailStep,
  otpStep
}

@Component({
  selector: 'app-connect-to-mailiz',
  templateUrl: './connect-to-mailiz.component.html',
  styleUrls: [
    './connect-to-mailiz.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class ConnectToMailizComponent implements OnInit {

  public formGroup: FormGroup;
  public formGroupOTP: FormGroup;
  public isOTPNeeded = true;
  public idNat: string;
  public identifiantsTemporaires: IdentifiantsTemporairesConnexion;

  public connectionStep: MailizConnectStep = MailizConnectStep.mailStep;
  public connectionStepTemplate = MailizConnectStep;

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter<string>();

  //la fonction OnGlobalClick pour la fermeture de la modale en cliquant en dehors n'est pas utilisée.
  //Remplacée par un bouton "Annuler"
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
        this.closeModal();
    }
  }

  constructor(
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _mssSrv: MssServiceFactory,
    private _formBuilder: FormBuilder,
    private _resourceSrv: RessourceService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.formGroup = this._formBuilder.group({
      idnat: [this.idNat, [Validators.required]],
      password: ['', Validators.required],
      typeOTP: ['mail', Validators.required]
    });
    this.formGroupOTP = this._formBuilder.group({
      otp: ['', [Validators.required]]
    });
  }

  public closeModal(res?: string): void {
    this.closeEmitter.emit(res);
  }

  public async connectToMSSWithID(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      const login = {
        idNat: this.formGroup.get('idnat').value,
        password: this.formGroup.get('password').value,
        typeOTP: this.formGroup.get('typeOTP').value
      };

      this.idNat = login.idNat;

      // On s'authentifie auprès de la MSS
      this._mssSrv.switchService(MssTypeService.mailiz);
      this.identifiantsTemporaires = await this._mssSrv.getService().connectToMSSByIDNAT(login.idNat, login.password, login.typeOTP);
      this.isOTPNeeded = this._mssSrv.getService().isOTPNeeded();
      this.connectionStep = MailizConnectStep.otpStep;
    } catch (e) {
      if (e.code === 409) {
        this._openHTMLError(e.message);
      } else {
        console.error(e);
        this._openAlertModal(e.toString(), 'Une erreur est survenue lors de la connexion par identifiant');
      }
    } finally {
      loading.destroy();
    }
  }

  public async connectToMSSWithOTP(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    let closeModal = false;

    try {
      const otp = this.formGroupOTP.get('otp').value;

      // On s'authentifie auprès de la MSS
      await this._mssSrv.getService().validateOTP(otp, this.identifiantsTemporaires);
      // On stocke l'identifiant de connexion
      this._mssSrv.getService().storeToken(this.identifiantsTemporaires.JSESSIONID, this.idNat);

      this.closeModal('connected');
      closeModal = true;
    } catch (e) {
      console.log('erreur undefined : ', e);
      if (e && e.code && e.code === 409) {
        this._openHTMLError(`Impossible de se connecter, une erreur est survenue (${e.message}).<br /><br />Veuillez vérifier l'OTP fourni par la MSS.`);
      } else if (e) {
        console.error(e);
        this._openAlertModal(e.toString(), 'Une erreur est survenue lors de la connexion par mail');
      } else {
        this._openAlertModal('Une erreur inconnue est survenue lors de la connexion par mail', 'Erreur');
      }
    } finally {
      loading.destroy();
      if (closeModal) {
        this.closeModal();
      }
    }
  }

  private _openAlertModal(msg: string, title = 'Erreur'): void {
    this._modalSrv.openAlert(
      this._viewContainerRef,
      title,
      msg
    );
  }

  private _openHTMLError(htmlContent: string): void {
    const modal = this._modalSrv.openModal<HtmlErrorComponent>(
      this._viewContainerRef,
      HtmlErrorComponent
    ) as ComponentRef<HtmlErrorComponent>;
    modal.instance.htmlContent = htmlContent;
    const sub = modal.instance.closeEmitter.subscribe(() => {
      modal.destroy();
      sub.unsubscribe();
    });
  }

}
